import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import { VTCLOUD_MARKETPLACE } from 'constants/api'
import { NS_TRANS } from 'constants/common'
import { WIDTH_CONTENT_DIALOG } from 'constants/ui.contants'
import { useTranslation } from 'react-i18next'
import { color } from 'theme'
import { setCloseDialogCC } from 'utils/helpers'
import { DIALOG_ID } from './constant'
import DialogBaseCC from './DialogBaseCC'

const DialogLimitCreate = () => {
    const { t } = useTranslation(NS_TRANS.PG_WHITEBOARD)
    const propsDialog = useLegacyDialogProps();
    const { title, content } = propsDialog
    
    const handleOpenMarketplace = () => {
        window.open(VTCLOUD_MARKETPLACE, "_blank")
        setCloseDialogCC()
    }

    return (
        <DialogBaseCC id={DIALOG_ID.LIMIT_CREATE} title={title}>
            <DialogContent sx={{ width: { xs: 1, sm: WIDTH_CONTENT_DIALOG.MEDIUM } }}>
                <DialogContentText>
                    <Box sx={{ marginTop: '11px', color: color.black, wordBreak: 'break-word' }}>
                        {content}
                    </Box>
                    <Box sx={{ color: color.black, wordBreak: 'break-word' }}>
                        {t("dialog.limitedCreateTarget1")}
                        <span className='vmp-link' onClick={handleOpenMarketplace}>{t('dialog.here')}</span>
                        {t("dialog.limitedCreateTarget2")}
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('dialog.cancel')}</Button>
                <Button onClick={handleOpenMarketplace}>{t('dialog.upgradeNow')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogLimitCreate